export default "__VITE_ASSET__nGFJ$RhV__"